import PortalProgram from '@classes/Program'
import BodySpinner from '@components/BodySpinner'
import EmptyFlexLessons from '@components/EmptyLessons/EmptyFlexLessons'
import Error from '@components/Error'
import QueryLearningPath from '@layouts/LearningPath/QueryLearningPath'
import ActiveLiveCoaching from '@layouts/Scheduling/ScheduleOptions/ActiveLiveCoaching'
import CardSingleBook from '@layouts/Scheduling/ScheduleOptions/CardSingleBook'
import LiveCoachingLocked from '@layouts/Scheduling/ScheduleOptions/LiveCoachingLocked'
import { FLEX_LEVEL_STATUS } from '@utils/constants'
import { LP_STATUS } from '@utils/constants/learningPath'
import React from 'react'

const OptionBodyFlex: React.FC<{ StudentProgram: PortalProgram }> = ({ StudentProgram }) => {
  return (
    <QueryLearningPath>
      {({ loading, error, LearningPaths }) => {
        if (loading) {
          return <BodySpinner />
        }

        const Path = LearningPaths.getLearningPathById(
          LearningPaths.getLearningPathById(StudentProgram.LMSMaterialId)?.MaterialCore?.LPID
        )
        const status = Path?.LCSStatus
        const lvlComplete = StudentProgram.program?.FlexLevelStatus === FLEX_LEVEL_STATUS.ENROLMENT_COMPLETED

        if (error || !status) {
          return <Error statusCode={400} />
        }

        switch (status) {
          case LP_STATUS.LOCKED:
            return <LiveCoachingLocked />
          case LP_STATUS.CUSTOM_BOOKED:
            return <ActiveLiveCoaching />
          default:
            // @ts-ignore
            return lvlComplete ? (
              <EmptyFlexLessons top="md" programId={StudentProgram.program?.ProgramId} />
            ) : (
              <CardSingleBook {...StudentProgram.program} />
            )
        }
      }}
    </QueryLearningPath>
  )
}

export default OptionBodyFlex
